<template>
  <div>
    <el-col :xs="24" :lg="24" :md="24" :sm="24">
      <template v-if="mode=='createNew'">
        <div class="ticket-container">
          <div class="ticket-wrapper">
            <div class="select-group">
              <div>
                <div style="width:50%;">
                  <el-menu class="noborder-menu" mode="horizontal" @select="handleTypeSelect">
                    <el-submenu index="type">
                      <template slot="title">
                        <i class="el-icon-collection-tag" style="font-size: 16px;position:relative;top:1px;color:#333;width:16px;"></i>
                        <label style="color: #333;">{{ ticketTypeDisplay }}</label>
                      </template>
                      <template v-for="item in ticketTypes">
                        <el-submenu v-if="item.next_level_list.length" :index="'type'+'-'+item.id">
                          <template slot="title">{{ item.name }}</template>
                          <el-menu-item v-for="subitem in item.next_level_list" :index="'type'+item.id+'-'+subitem.id" :key="item.id+'-'+subitem.id">{{ subitem.name }}</el-menu-item>
                        </el-submenu>
                        <el-menu-item v-else :index="'type'+'-'+item.id">
                          {{ item.name }}
                        </el-menu-item>
                      </template>
                    </el-submenu>
                  </el-menu>
                </div>
                <div style="width:50%;">
                  <el-menu class="noborder-menu" mode="horizontal" @select="handlePrioritySelect">
                    <el-submenu index="priority">
                      <template slot="title">
                        <span class="priority-label" :class="{'P1':ticketPriorityDisplay=='高','P2':ticketPriorityDisplay=='中','P3':ticketPriorityDisplay=='低'}"></span>
                        <label style="color: #333;margin-left: 6px;">{{ ticketPriorityDisplay }}</label>
                      </template>
                      <el-menu-item v-for="item in ticketPriorities" :index="'priority'+'-'+item.id" :key="item.id">
                        <span class="priority-label" :class="{'P1':item.name=='高','P2':item.name=='中','P3':item.name=='低'}"></span>
                        <label style="color: #333;margin-left: 6px;">{{ item.name }}</label>
                      </el-menu-item>
                    </el-submenu>
                  </el-menu>
                </div>
              </div>
              <div>
                <div style="width:50%;">
                  <el-menu class="noborder-menu" mode="horizontal" @select="handleAssignToSelect">
                    <el-submenu index="account">
                      <template slot="title">
                        <i class="el-icon-thumb" style="font-size: 16px;transform: rotate(90deg);color:#333;width:16px;"></i>
                        <label style="color: #333;">{{ ticketAccountDisplay }}</label>
                      </template>
                      <el-submenu v-for="item in singleList" :index="'account'+'-'+item.id" :key="item.id">
                        <template slot="title">{{ item.name }}</template>
                        <el-menu-item v-for="subitem in item.account_list" :index="'account'+'-'+item.id+'-'+subitem.id" :key="item.id+'-'+subitem.id">{{ subitem.name }}</el-menu-item>
                      </el-submenu>
                    </el-submenu>
                  </el-menu>
                </div>
                <div style="width:50%;">
                  <el-menu class="noborder-menu" mode="horizontal" @select="handleVisibleSelect">
                    <el-submenu index="visible">
                      <template slot="title">
                        <i class="el-icon-view" style="font-size: 16px;color:#333"></i>
                        <label style="color: #333;">{{ ticketVisibleDisplay(r.visible_range_id) }}</label>
                      </template>
                      <el-menu-item v-for="item in ticketVisible" :index="'visible'+'-'+item.id" :key="item.id">
                        {{ item.name }}
                      </el-menu-item>
                    </el-submenu>
                  </el-menu>
                </div>
              </div>
            </div>
            <div style="margin:20px 0 10px;color:black;">
              关联项
            </div>
            <div style="display:flex;margin:0 0 20px;justify-content: space-between;">
              <div style="width:45%;">
                <div style="display: flex;align-items: center;">
                  <YueDanIpt style="width:100%;"  model="order_no" :object="newTicket" placeholder="任务号" @blur="searchOrder"/>
                </div>
                <div style="display: flex;align-items: center;margin-top:10px;">
                  <el-select style="width:100%;" v-model="newTicket.merchant_id" clearable filterable :filter-method="filterSearch"
                    class="customHeightSelect" placeholder="商家">
                    <el-option v-for="item in merchantOptions" :key="item.id" :label="item.value" :value="item.id"></el-option>
                  </el-select>                
                </div>
                <div style="display: flex;align-items: center;margin-top:10px;">
                  <el-select style="width:100%"
                          v-model="newTicket.transport_company_id"
                          clearable
                          filterable
                          :filter-method="remotetransportSearch"
                          class="customHeightSelect"
                          placeholder="转运公司">
                          <el-option
                            v-for="item in remoteTrasports"
                            :key="item.id"
                            :label="item.value"
                            :value="item.id"></el-option>
                  </el-select>
                </div>
                <div v-if="order_exception_list.length" style="display: flex;align-items: center;margin-top:10px;">
                  <el-select style="width:100%;" class="customHeightSelect" v-model="newTicket.order_exception" placeholder="异常">
                    <el-option
                      v-for="item in order_exception_list"
                      :key="item.value"
                      :label="item.content"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </div>
              </div>
              <div style="width:45%;">
                <div style="margin-bottom:10px;">
                  <YueDanIpt style="width:100%;"  model="subject" :object="newTicket" placeholder="主题"/>
                </div>
                <div style="margin-bottom:10px;">
                  <div class="progress-row">
                    <el-input style="width:100%;" type="textarea" :rows="4" ref="description" v-model="newTicket.description" placeholder="描述内容" @blur="handlerTextarea"></el-input>
                  </div>
                </div>
                <div>
                  <el-button style="width:100%;" :loading="isSubmitting" class="block" type="primary" @click="submit">提 交</el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="ticket-container">
          <div class="ticket-wrapper">
            <div class="select-group">
              <div>
                <div style="width:50%;">
                  <el-menu class="noborder-menu" mode="horizontal" @select="handleTypeSelect">
                    <el-submenu index="type">
                      <template slot="title">
                        <i class="el-icon-collection-tag" style="font-size: 16px;position:relative;top:1px;color:#333;width:16px;"></i>
                        <label style="color: #333;">{{ ticketTypeDisplay }}</label>
                      </template>
                      <template v-for="item in ticketTypes">
                        <el-submenu v-if="item.next_level_list.length" :index="'type'+'-'+item.id">
                          <template slot="title">{{ item.name }}</template>
                          <el-menu-item v-for="subitem in item.next_level_list" :index="'type'+item.id+'-'+subitem.id" :key="item.id+'-'+subitem.id">{{ subitem.name }}</el-menu-item>
                        </el-submenu>
                        <el-menu-item v-else :index="'type'+'-'+item.id">
                          {{ item.name }}
                        </el-menu-item>
                      </template>
                    </el-submenu>
                  </el-menu>
                </div>
                <div style="width:50%;">
                  <el-menu class="noborder-menu" mode="horizontal" @select="handlePrioritySelect">
                    <el-submenu index="priority">
                      <template slot="title">
                        <span class="priority-label" :class="{'P1':ticketPriorityDisplay=='高','P2':ticketPriorityDisplay=='中','P3':ticketPriorityDisplay=='低'}"></span>
                        <label style="color: #333;margin-left: 6px;">{{ ticketPriorityDisplay }}</label>
                      </template>
                      <el-menu-item v-for="item in ticketPriorities" :index="'priority'+'-'+item.id" :key="item.id">
                        <span class="priority-label" :class="{'P1':item.name=='高','P2':item.name=='中','P3':item.name=='低'}"></span>
                        <label style="color: #333;margin-left: 6px;">{{ item.name }}</label>
                      </el-menu-item>
                    </el-submenu>
                  </el-menu>
                </div>
              </div>
              <div>
                <div style="width:50%;">
                  <el-menu class="noborder-menu" mode="horizontal" @select="handleAssignToSelect">
                    <el-submenu index="account">
                      <template slot="title">
                        <i class="el-icon-thumb" style="font-size: 16px;transform: rotate(90deg);color:#333;width:16px;"></i>
                        <label style="color: #333;">{{ ticketAccountDisplay }}</label>
                      </template>
                      <el-submenu v-for="item in singleList" :index="'account'+'-'+item.id" :key="item.id">
                        <template slot="title">{{ item.name }}</template>
                        <el-menu-item v-for="subitem in item.account_list" :index="'account'+'-'+item.id+'-'+subitem.id" :key="item.id+'-'+subitem.id">{{ subitem.name }}</el-menu-item>
                      </el-submenu>
                    </el-submenu>
                  </el-menu>
                </div>
                <div style="width:50%;">
                  <el-menu class="noborder-menu" mode="horizontal" @select="handleVisibleSelect">
                    <el-submenu index="visible">
                      <template slot="title">
                        <i class="el-icon-view" style="font-size: 16px;color:#333"></i>
                        <label style="color: #333;">{{ ticketVisibleDisplay(r.visible_range_id) }}</label>
                      </template>
                      <el-menu-item v-for="item in ticketVisible" :index="'visible'+'-'+item.id" :key="item.id">
                        {{ item.name }}
                      </el-menu-item>
                    </el-submenu>
                  </el-menu>
                </div>
              </div>
            </div>
            <div style="display:flex;margin:10px 0 0;">
              <template v-if="contenteditmode.relation">
                <div style="display: flex;align-items: center;margin-right:20px;">
                  <YueDanIpt style="width:180px;"  model="order_no" :object="newTicket" placeholder="任务号" @blur="handleRelation('order_no')"/>
                </div>
                <div style="display: flex;align-items: center;margin-right:20px;">
                  <el-select style="width:200px"
                          v-model="newTicket.transport_company_id"
                          clearable
                          filterable
                          :filter-method="remotetransportSearch"
                          class="customHeightSelect"
                          @change="handleRelation('transport_company_id')"
                          placeholder="转运公司">
                          <el-option
                            v-for="item in remoteTrasports"
                            :key="item.id"
                            :label="item.value"
                            :value="item.id"></el-option>
                  </el-select>
                </div>
                <div style="display: flex;align-items: center;margin-right:20px;">
                  <el-select style="width:200px;" v-model="newTicket.merchant_id" clearable filterable :filter-method="filterSearch"
                    class="customHeightSelect" placeholder="商家" @change="handleRelation('merchant_id')">
                    <el-option v-for="item in merchantOptions" :key="item.id" :label="item.value" :value="item.id"></el-option>
                  </el-select>                
                </div>
                <div v-if="order_exception_list.length" style="display: flex;align-items: center;">
                  <el-select style="width:200px;" class="customHeightSelect" v-model="newTicket.order_exception" placeholder="异常" @change="handleRelation('order_exception')">
                    <el-option
                      v-for="item in order_exception_list"
                      :key="item.value"
                      :label="item.content"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </div>
              </template>
              <template v-else>
                <div class="relation">
                  <label v-if="norelation">无关联项</label>
                  <label v-if="newTicket.order_no">任务#</label><label>{{ newTicket.order_no }}</label>
                  <span style="margin-left:3px;" v-if="newTicket.order_no" v-clipboard:copy="newTicket.order_no"
                          v-clipboard:success="onCopyOrderNo">
                          <i class="el-icon-check" v-if="copyOrderNoSuccess"></i>
                          <i class="el-icon-news" style="cursor: pointer;" title="复制" v-if="!copyOrderNoSuccess"></i>
                  </span>
                  <label v-if="newTicket.merchant_id">{{ merchantOptions.find(i=>i.id==newTicket.merchant_id).value}}</label>
                  <label v-if="newTicket.transport_company_id">{{ remoteTrasports.find(i=>i.id==newTicket.transport_company_id).value }}</label>
                  <label v-if="newTicket.order_exception">{{ order_exception_list.length && newTicket.order_exception && order_exception_list.find(i=>i.value==newTicket.order_exception)?order_exception_list.find(i=>i.value==newTicket.order_exception).content:'' }}</label>
                  <span class="editIcon" @click="relationFunc">
                    <i class="el-icon-edit-outline"></i>
                  </span>
                </div>
              </template>
            </div>
            <div>
                <div style="margin:5px 0 10px;">
                    <template v-if="contenteditmode.topic">
                      <YueDanIpt style="width:100%;margin-top:10px;"  model="subject" :object="r" placeholder="主题" @blur="handleTopicBlur"/>
                    </template>
                    <template v-else>
                        <span class="content-editable input" style="font-size: 18px;" @click="handlerTopic">{{ r.subject }}
                          <span class="editIcon">
                            <i class="el-icon-edit-outline" style="font-size: 18px;"></i>
                          </span>
                        </span>
                    </template>
                </div>
                <div style="margin:5px 0 20px;" v-if="r.attachments && r.attachments.length">
                  <div class="attachment-item" v-for="(item,index) in r.attachments" :key="index">
                    <i class="el-icon-link" style="font-size: 16px;position: relative;top:1px;"></i>
                    <a target="_blank" :href="item.content">{{ item.contentName }}</a>
                  </div>
                </div>
                <div style="margin-bottom:10px;">
                    <div class="progress-row">
                      <div style="width:24%;">
                        <p style="font-size: 16px;padding-bottom: 5px;">{{ r.createDateDisplay }}</p>
                        <p style="color:#666;line-height:1.5">{{ r.createTimeDisplay }}</p>
                      </div>
                      <div style="flex:1;">
                        <p style="padding-bottom: 5px;display:flex;align-items: center;">
                          <i class="el-icon-user" style="font-size: 16px;color:#333;width:16px;"></i>
                          <label style="font-size: 16px;margin-left:5px;">{{ r.created_by_username }}</label>
                        </p>
                        <div>
                            <template v-if="contenteditmode.description">
                              <el-input class="customHeightInput" style="width:100%;" type="textarea" ref="description" v-model="r.description" placeholder="描述内容" @blur="handlerTextarea"></el-input>
                            </template>
                            <template v-else>
                              <span class="content-editable textarea" @click="handler2Textarea">{{ r.description }}
                                <span class="editIcon">
                                  <i class="el-icon-edit-outline"></i>
                                </span>
                              </span>
                            </template>
                        </div>
                      </div>
                    </div>
                </div>
            </div>
            
            <div class="progress">
              <template v-for="comment in r.comments">
                <div v-if="commentVisible(comment.visible_range_id)" class="progress-row" >
                  <div style="width:24%;">
                    <p style="font-size: 16px;padding-bottom: 5px;">{{ comment.replyDateDisplay }}</p>
                    <p style="color:#666;line-height:1.5"">{{ comment.replyTimeDisplay }}</p>
                  </div>
                  <div style="flex:1">
                    <div class="comment-status-row">
                      <i class="el-icon-user" style="font-size: 16px;color:#333;width:16px;"></i>
                      <label style="font-size: 16px;margin-left:5px;">{{ comment.replied_by_username }}</label>
                      <label style="margin:0 5px;font-size: 16px;">{{ ticketStatusDisplay(comment.status_id) }}</label> 
                      <i class="el-icon-view" style="font-size: 16px;color:#333;cursor:pointer;margin-right:5px;" @click="handle(comment)"></i>
                          <el-menu style="width:auto !important;" v-show="r.visible_range_id != comment.visible_range_id || comment.editMode" class="noborder-menu" mode="horizontal" @select="handleVisibleSelectComment($event,comment)">
                            <el-submenu index="visible">
                              <template slot="title">
                                <label style="color: #333;">{{ ticketVisibleDisplay(comment.visible_range_id) }}</label>
                              </template>
                              <el-menu-item v-for="item in ticketVisible" :index="'visible'+'-'+item.id" :key="item.id">
                                {{ item.name }}
                              </el-menu-item>
                            </el-submenu>
                          </el-menu>
                    </div>
                    <div style="position:relative;top:-5px;">
                        <p style="line-height: 1.5;" v-html="comment.content"></p>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
        <div class="reply_div" v-if="r.status_id!=14">
          <el-form>
            <el-form-item label="" prop="replycontent">
              <el-input type="textarea" v-model="replycontent" placeholder="回复内容"></el-input>
            </el-form-item>
            <el-form-item label="" prop="need_send_sms" v-if="r.source=='0' || r.order_no_list.length">
              <el-checkbox v-model="need_send_sms"></el-checkbox>
              <span style="margin-left:5px;position: relative;top: 0.5px;">
                短信通知{{ clientName }}：{{ replyTemplate.replace('{1}',r.ticket_number).replace('{2}',replycontent)}}
              </span>
            </el-form-item> 
            <el-form-item label="">
              <div style="display:flex;align-items: center;justify-content: space-between;">
                <div>
                  <el-menu class="noborder-menu" mode="horizontal" @select="handleReplyVisibleSelect">
                  <el-submenu index="visible">
                    <template slot="title">
                      <i class="el-icon-view" style="font-size: 16px;color:#333"></i>
                      <label style="color: #333;">{{ ticketVisibleDisplay(replyVisible) }}</label>
                    </template>
                    <el-menu-item v-for="item in ticketVisible" :index="'visible'+'-'+item.id" :key="item.id">
                      {{ item.name }}
                    </el-menu-item>
                  </el-submenu>
                </el-menu>
                </div>
                <div style="display:flex;align-items: center;">
                  <el-button :loading="isSubmitting" type="default" style="height:40px;" @click="replyHandler('')">发 布</el-button>
                  <el-menu class="noborder-menu menu-button" mode="horizontal" @select="handleReplySelect">
                    <el-submenu index="visible" :disabled="replyDisabled">
                      <template slot="title">
                        <label>发布并更新状态</label>
                      </template>
                      <template v-for="item in ticketStatus">
                        <el-submenu v-if="item.next_level_list.length" :index="'status'+'-'+item.id">
                          <template slot="title">{{ item.name }}</template>
                          <el-menu-item v-for="subitem in item.next_level_list" :index="'status'+'-'+item.id+'-'+subitem.id" :key="item.id+'-'+subitem.id">{{ subitem.name }}</el-menu-item>
                        </el-submenu>
                        <el-menu-item v-else :index="'status'+'-'+item.id">
                          {{ item.name }}
                        </el-menu-item>
                      </template>
                    </el-submenu>
                  </el-menu>
                </div>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </template>
    </el-col>
  </div>
</template>

<script>
//import Order from '../list/Order'
import YueDanIpt from '../../../components/YueDanIpt'
import { API_HOST, FILE_HOST,SPEC_MAPPER } from '../../../services/constant.js'
import api from '../../../services/api.js'
let _ = require('lodash')

export default {
  name: 'OrderList',
  props:['r','mode','ticketStatus','ticketPriorities','singleList'
  ,'ticketTypes','ticketVisible','merchants','expressList','exceptionTypes','order','relationReset','replyTemplate'],
  components: {
    //Order:Order,
    YueDanIpt:YueDanIpt
  },
  computed:{
    clientName(){
      if(this.r.source=='0')
          return this.r.created_by_username
      else if(this.r.order_no_list.length){
          return this.r.order_no_map[this.r.order_no_list[0]].username
      }
    },
    norelation(){
      if(this.newTicket.order_no)
        return false
      if(this.newTicket.merchant_id)
        return false
      if(this.newTicket.transport_company_id)
        return false
      if(this.newTicket.order_exception)
        return false
      return true
    },
    ticketTypeDisplay(){
      if(this.r.type_id && this.r.type_id!='0'){
        let name=''
        for(var i=0,length=this.ticketTypes.length;i<length;i++){
          let o = this.ticketTypes[i].next_level_list.find(j=>j.id==this.r.type_id)
          if(o){
            name = o.name;
            break;
          }
        }
        return name
      }
      else
        return '类型未分配'
    },
    ticketStatusDisplay(){
      return (status_id)=>{
        if(status_id){
          let name = ''
          for(var i=0,length=this.ticketStatus.length;i<length;i++){
            let o = this.ticketStatus.find(i=>i.id==status_id)
            if(o){
              name = o.name
              break;
            }
          }
          if(!name){
            for(var i=0,length=this.ticketStatus.length;i<length;i++){
              if(this.ticketStatus[i].next_level_list.length){
                let o_o = this.ticketStatus[i].next_level_list.find(i=>i.id==status_id)
                if(o_o){
                  name = o_o.name
                  break;
                }
              }
            }
          }
          return name
        }
        else
          return ''
        }
    },
    ticketPriorityDisplay(){
      if(this.r.priority_id)
        return this.ticketPriorities.find(i=>i.id==this.r.priority_id).name
      else
        return ''
    },
    ticketVisibleDisplay(){
      return (visible_range_id)=>{
        if(visible_range_id)
          return this.ticketVisible.find(i=>i.id==visible_range_id).name
        else
          return ''
      }
    },
    ticketAccountDisplay(){
      let name = []
      if(this.r.assigned_to_group && this.r.assigned_to_group!='0'){
        name.push(this.singleList.find(i=>i.id==this.r.assigned_to_group).name)
      }
      if(this.r.assigned_to && this.r.assigned_to!='0')
        name.push(this.singleList.find(i=>i.id==this.r.assigned_to_group).account_list.find(j=>j.id==this.r.assigned_to).name)
      if(name.length){
        return name.join(' | ')
      }
      else
        return '未指派'
    }
  },
  watch:{
    'relationReset':{
      handler(val){
        if(!val)
          this.contenteditmode.relation=false
      }
    },
    'r.visible_range_id':{
      immediate:true,
      handler(val){
        this.replyVisible = val
      }
    },
  },
  data() {
    return {
      contenteditmode:{
        relation:false,
        topic:false,
        description:false,
        scope:false,
      },
      /*form:{
        type_id:'',
        assigned_to_group:'',
        assigned_to:'',
        priority_id:'',
        description:'',
        subject:'',
        visible_range_id:'',
        order_no_list:[],
        order_exception_id_list:[]
      }, */
      replyDisabled:false,
      replycontent:'',
      need_send_sms:false,
      replyVisible:'',
      isSubmitting:false,
      merchantOptions:[],
      remoteTrasports:[],
      newTicket:{
        subject:'',
        order_no:'',
        order_exception:'',
        merchant_id:'',
        transport_company_id:''
      },
      copyOrderNoSuccess:false,
      order_exception_list:{}
    }
  },
  async mounted() {
    this.newTicket.type_id=this.r.type_id
    this.newTicket.priority_id=this.r.priority_id
    this.newTicket.assigned_to_group=this.r.assigned_to_group
    this.newTicket.assigned_to=this.r.assigned_to
    this.newTicket.visible_range_id=this.r.visible_range_id
    this.newTicket.subject=this.r.subject

    if(this.r.order_no_list && this.r.order_no_list.length){
      this.newTicket.order_no=this.r.order_no_list[0]

      if(this.order){
        this.order_exception_list=[]
        this.order.exception_list.forEach((ex)=>{
          this.order_exception_list.push({value:ex.id,content:ex.type_name})
        })
      }
      else
        await this.searchOrder()
    }
    if(this.r.order_exception_list && this.r.order_exception_list.length){
      this.newTicket.order_exception=this.r.order_exception_list[0].id
    }
    if(this.r.merchant_id_list && this.r.merchant_id_list.length){
      this.newTicket.merchant_id=this.r.merchant_id_list[0]
      let m=this.merchants.find(i=>i.merchant_id==this.newTicket.merchant_id)
      this.merchantOptions.push({ value: m.merchant_name, id: m.merchant_id })
    }
    if(this.r.transport_express_id_list && this.r.transport_express_id_list.length){     
      this.newTicket.transport_company_id=this.r.transport_express_id_list[0]
      let m=this.expressList.find(i=>i.id==this.newTicket.transport_company_id)
      this.remoteTrasports.push({ value: m.name, id: m.id })
    }
  },
  methods: {
    getAttachName(type){
      switch(type){
        case 'product':
          return '商品网址';
        default:
          return '';
      }
    },
    onCopyOrderNo(e) {
      this.copyOrderNoSuccess = true
      setTimeout(() => {
        this.copyOrderNoSuccess = false
      }, 2000)
    },
    relationFunc(){
      this.$emit('reset')
      this.contenteditmode.relation=true
    },
    async searchOrder(){
      if(!this.newTicket.order_no){
        this.$emit('searchOrder',{ticket:this.r,order:null})
        return
      }
      let params={page:1,limit:1,keyword:this.newTicket.order_no.replace(/ /g,'')}
      let res = await api.getSingleOrders(this, params)
      res = res.body
      if(res.result && res.result.length){
        let order = res.result[0]
        console.log('searchorder',order)
        this.$emit('searchOrder',{ticket:this.r,order:order});
        this.order_exception_list=[]
        order.exception_list.forEach((ex)=>{
          this.order_exception_list.push({value:ex.id,content:ex.type_name})
        })
      }
    },
    submit(){
      this.$emit('submit',this.newTicket)
    },
    remotetransportSearch(queryString,callback){
      this.remoteTrasports=[]
      let res=this.expressList.filter((i)=>{
        return i.name.toLowerCase().indexOf(queryString.toLowerCase())>-1
      })
      _.each(res,item => {
        if(item.type == '2') {
          this.remoteTrasports.push({value:item.name,id:item.id})
        }
      })
      if(callback)
          callback()
    },
    filterSearch(val) {
      this.merchantOptions = []
      let mers = [];
      if (val) {
        mers = this.merchants.filter((item) => {
          return item.merchant_name.toLowerCase().indexOf(val.toLowerCase()) > -1
        })
      }
      else {
        mers = this.merchants;
      }
      mers.forEach(item => {
        this.merchantOptions.push({ value: item.merchant_name, id: item.merchant_id })
      })
    },
    handle(c){
      c.editMode=!c.editMode
      this.$forceUpdate()
    },
    commentVisible(visible_range_id){
      let single_type=this.$localStorage.get('single_type')
      let role=this.$localStorage.get("role")
      switch(visible_range_id){
        case '1':
          return true;
        case '2':
          if(single_type=='1')
            return true
          else
            return false;
        case '3':
          if(role=='0')
            return false
          else
            return true
      }
      return false
    },
    setReplyVisible(data){
      this.replyVisible=data
    },
    generateDateDisplay(datestring){
      let today=new Date()
      let yesterday=new Date(today.getTime() -24*60*60*1000)
      let today_string=this.$moment(today).format('YYYY-MM-DD')
      let yest_string=this.$moment(yesterday).format('YYYY-MM-DD')
      if(datestring==today_string)
        return '今天';
      if(datestring==yest_string)
        return '昨天';
      return datestring
    },
    handleReplySelect(key){
      let arr = key.split('-')
      let status=arr.length>2?arr[2]:arr[1]
      this.replyHandler(status)
    },
    async replyHandler(status){
      if(!this.replycontent)
        return
      this.replyDisabled = true
      let params = {}
      params.visible_range_id=this.replyVisible;
      params.content=this.replycontent
      params.status_id=status || this.r.status_id
      params.ticket_id=this.r.id
      params.need_send_sms=this.need_send_sms?'Y':'N'
      if(this.r.source=='0')
          params.receiver_account_id=this.r.created_by
        else if(this.r.order_no_list.length){
          params.receiver_account_id=this.r.order_no_map[this.r.order_no_list[0]].account_id
      }
      let res = await api.replyTicket(this,params)
      if(res.body.status=='ok'){
        this.replycontent=''
        this.need_send_sms=false
        let reply = res.body.result
        reply.replyDateDisplay=this.generateDateDisplay(reply.replied_date.split(' ')[0])
        reply.replyTimeDisplay=reply.replied_date.split(' ')[1];
        if(this.order)
          this.order.update_time=reply.replied_date;
        if(!this.r.comments)
          this.r.comments=[]
        this.r.status_id=params.status_id
        this.r.comments.push(reply)
        this.replyDisabled = false
      }
    },
    async handleTopicBlur(){
      this.contenteditmode.topic=false
      if(this.mode!='createNew'){
        let res = await api.updateTicket(this,{id:this.r.id,subject:this.r.subject});
        if(res.body.status=='ok' && this.order){
          this.order.update_time=res.body.result.updated_date;
        }
      }
    },
    async handleAssignToSelect(index){
      let arr = index.split('-')
      this.r.assigned_to_group=arr[1]
      this.r.assigned_to=arr[2]
      if(this.mode!='createNew'){
        let res = await api.updateTicket(this,{id:this.r.id,assigned_to_group:this.r.assigned_to_group,assigned_to:this.r.assigned_to});
        if(res.body.status=='ok' && this.order){
          this.order.update_time=res.body.result.updated_date;
        }
      }
      else{
        this.newTicket.assigned_to_group=this.r.assigned_to_group
        this.newTicket.assigned_to=this.r.assigned_to
      }
    },
    async handleTypeSelect(e){
      let arr = e.split('-')
      this.r.type_id=arr.length>2?arr[2]:arr[1]
      if(this.mode!='createNew'){
        let res = await api.updateTicket(this,{id:this.r.id,type_id:this.r.type_id});
        if(res.body.status=='ok' && this.order){
          this.order.update_time=res.body.result.updated_date;
        }
      }
      else
        this.newTicket.type_id=this.r.type_id
    },
    async handlePrioritySelect(e){
      let arr = e.split('-')
      this.r.priority_id=arr[1]
      if(this.mode!='createNew'){
        let res = await api.updateTicket(this,{id:this.r.id,priority_id:this.r.priority_id});
        if(res.body.status=='ok' && this.order){
          this.order.update_time=res.body.result.updated_date;
        }
      }
      else
        this.newTicket.priority_id=this.r.priority_id
    },
    handleReplyVisibleSelect(e){
      let arr = e.split('-')
      this.replyVisible=arr[1]
    },
    async handleVisibleSelect(e){
      let arr = e.split('-')
      this.r.visible_range_id=arr[1]
      this.replyVisible=this.r.visible_range_id
      if(this.mode!='createNew'){
        let res = await api.updateTicket(this,{id:this.r.id,visible_range_id:this.r.visible_range_id});
        if(res.body.status=='ok' && this.order){
          this.order.update_time=res.body.result.updated_date;
        }
      }
      else
        this.newTicket.visible_range_id=this.r.visible_range_id
    },
    async handleVisibleSelectComment(e,comment){
      let arr = e.split('-')
      comment.visible_range_id=arr[1]
      await api.updateComment(this,{id:comment.id,visible_range_id:comment.visible_range_id});
      if(res.body.status=='ok' && this.order){
          this.order.update_time=res.body.result.updated_date;
        }
      this.$forceUpdate()
    },
    handlerTopic(){
      this.contenteditmode.topic=true
      /*this.$nextTick(()=>{
        this.$refs.subject.focus()
      })*/
    },
    async handleRelation(type){
      let res={}
      switch(type){
        case 'order_no':
          this.searchOrder();
          this.$confirm('确认修改任务号？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
          }).then(async() => {
              let r_res = await api.updateTicket(this,{id:this.r.id,order_no_list:[this.newTicket.order_no.replace(/ /g,'')]});
          }).catch(() => {
                      
          });
          break;
        case 'merchant_id':
          res = api.updateTicket(this,{id:this.r.id,merchant_id_list:[this.newTicket.merchant_id]})
          if(res.body.status=='ok' && this.order){
              this.order.update_time=res.body.result.updated_date;
          }
          break;
        case 'transport_company_id':
          res = api.updateTicket(this,{id:this.r.id,transport_express_id_list:[this.newTicket.transport_company_id]})
          if(res.body.status=='ok' && this.order){
              this.order.update_time=res.body.result.updated_date;
          }
          break;
        case 'order_exception':
          res = api.updateTicket(this,{id:this.r.id,order_exception_id_list:[this.newTicket.order_exception]})
          if(res.body.status=='ok' && this.order){
              this.order.update_time=res.body.result.updated_date;
          }
          break;
      }
    },
    handlerScope(){
      this.contenteditmode.scope=true
      this.$nextTick(()=>{
        this.$refs.scope.focus()
      })
    },
    async handlerTextarea(){
      if(this.r.description)
        this.r.description = this.r.description.replace(/\n/g, '<br>')
      this.contenteditmode.description=false
      if(this.mode!='createNew'){
        let res = await api.updateTicket(this,{id:this.r.id,description:this.r.description})
        if(res.body.status=='ok' && this.order){
          this.order.update_time=res.body.result.updated_date;
        }
      }
    },
    handler2Textarea(){
      if(this.r.description)
        this.r.description = this.r.description.replace(/<br>/g, '\n')
      this.contenteditmode.description=true
      this.$nextTick(()=>{
        this.$refs.description.focus()
      })
    },
    async updateMail(index){
      this.$emit('updateMail',index)
    },   
  }
}
</script>

<style lang="scss" scoped>
  .select-group{
    display: flex;
    align-items: center;
    justify-content: space-between;
    &>div{
      display: flex;
      align-items: center;
      width:45%;
    }
  }
  .tag-label{
    background:black;
    color:white;
    display: inline-block;
    height: 30px;
    padding: 0 5px;
    border-radius: 5px;
    line-height: 30px;
  }
  .progress-row{
    display:flex;
  }
  .progress{
    .progress-row{
      padding:15px 0;
      border-top:1px solid #DCDFE6;
    }
  }
  .relation{
    .editIcon {
        cursor: pointer;
        display: none;
    }
    &:hover{
        .editIcon{
          display: inline-block;
        }
      }
  }
  .content-editable{
      border:1px solid transparent;
      border-radius: 4px;
      min-height: 40px;     
      display:block;
      cursor: pointer;
      .editIcon {
        cursor: pointer;
        display: none;
      }
      &.input{
        line-height: 40px;
        height:40px;
      }
      &.textarea{
        line-height: 1.5;
        min-height: 21px;
      }
      &:hover{
        .editIcon{
          display: inline-block;
        }
      }
    } 
  .info{
    margin-bottom: 10px;
  }
  .content_link{
    color:#303133;
  }
.ticket-container{
      padding:15px 0;
      &:first-child{
        padding-top:0;
      }
      &:last-child{
        padding-bottom:0;
        border-bottom:none;
      }
      &.order{
        display: flex;
        justify-content: space-between;
      }
    }
.ticket-wrapper{
      .product-wrapper-left.lika{
        margin-left:237px;
        &.taskDisplay{
          margin-left:200px;
        }
      }
      .product-wrapper-right{
        text-align:right;
      }
      &:last-child{
        margin-bottom:0;
      }
      &.order{
        flex:1;
        border-right: 1px solid #D7D7D7;
        padding-right: 25px;
        line-height:1;
      }
      .product-wrapper-right.order p{
        color:#888888;
      }
    }
    .product-item{
      display:flex;
      height:120px;
      margin-bottom:30px;
      &:first-child{
        padding-top:0;
      }
      &:last-child{
        border-bottom:0;
        padding-bottom: 0;
        margin-bottom:0;
      }
      .product-detail{
          display:flex;
          flex-direction:column;
          justify-content:space-between;
          flex:1;
          position:relative;
          top:-3px;
          margin-left:20px;
          .product-name{
            font-size: 14px;
            color: #333333;
          }
          .product-price{
            line-height: 32px;
            color: black;
            label{
              font-size: 18px;
            }
          }
          .product-price del{
            font-size: 16px;
          }
      }
    }
  .product-price label.danger{
    font-size: 18px;
    color:#FF4650;
  }

  .priority-label{
    display: inline-block;
    width:16px;
    height:16px;
    border-radius: 2px;
    position: relative;
    top:1px;
    &.P1{
      background-color: #FF4650;
    }
    &.P2{
      background-color: #e6a23c;
    }
    &.P3{
      background-color: #409eff;
    }
    &.P4{
      background-color: #909399;
    }
  }
  .comment-status-row{
    display:flex;
    align-items: center;
    line-height:20px;
    position:relative;
    top:-5px;
    .visible-view{
      display: inline-block;
    }
    .visible-edit{
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/orders/ticket/TicketBody.vue